import commercelayerSlice from "../slices/commercelayerSlice";

export const commercelayerReducers = {
  commercelayer: commercelayerSlice,
};
